import { Col, Form, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { CheckboxGroupButtons } from '@/components/_common';
import {
  QuestReportInvoiceSituation,
  QuestReportInvoiceTypes,
} from '@/core/domain/questReport/Reports/Invoice/Invoice.types';

const InvoiceCheckBoxs = () => {
  const intl = useIntl();
  const { Title } = Typography;

  const optionsType = [
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.type.partsInvoice',
      }),
      value: QuestReportInvoiceTypes.partsInvoice,
    },
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.type.serviceInvoice',
      }),
      value: QuestReportInvoiceTypes.serviceInvoice,
    },
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.type.consumerInvoice',
      }),
      value: QuestReportInvoiceTypes.consumerInvoice,
    },
  ];

  const situationType = [
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.situation.authorized',
      }),
      value: QuestReportInvoiceSituation.authorized,
    },
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.situation.canceled',
      }),
      value: QuestReportInvoiceSituation.canceled,
    },
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.situation.inTyping',
      }),
      value: QuestReportInvoiceSituation.inTyping,
    },
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.situation.validated',
      }),
      value: QuestReportInvoiceSituation.validated,
    },
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.situation.processing',
      }),
      value: QuestReportInvoiceSituation.processing,
    },
    {
      label: intl.formatMessage({
        id: 'report.invoice.form.situation.denied',
      }),
      value: QuestReportInvoiceSituation.denied,
    },
  ];

  return (
    <Row gutter={24}>
      <Col span={24}>
        <Title level={5}>
          {intl.formatMessage({ id: 'report.invoice.form.type' })}
        </Title>

        <Form.Item
          name="types"
          initialValue={[
            QuestReportInvoiceTypes.partsInvoice,
            QuestReportInvoiceTypes.serviceInvoice,
            QuestReportInvoiceTypes.consumerInvoice,
          ]}
        >
          <CheckboxGroupButtons options={optionsType} />
        </Form.Item>
      </Col>

      <Col>
        <Title level={5}>
          {intl.formatMessage({ id: 'report.invoice.form.situation' })}
        </Title>

        <Form.Item
          name="situations"
          initialValue={[QuestReportInvoiceSituation.authorized]}
        >
          <CheckboxGroupButtons options={situationType} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default InvoiceCheckBoxs;
